import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { Observable, take } from "rxjs";
import {
  CustomDetailComponent,
  DataService,
  NotificationService,
  SharedModule,
} from "@bb-vendure/admin-ui/core";
import {
  GetSmsShippingSettingsDocument,
  UpdateSmsShippingSettingsDocument,
} from "src/generated-gql/graphql";

/**
 * NY-13: dedicated toggle card (embedded on the Global Settings page) to turn
 * the shipping SMS on/off per customer type. Values are stored on GlobalSettings
 * custom fields (read here via entity$) and saved via a dedicated mutation that
 * writes them directly server-side — reliable, unlike the standard form.
 */
@Component({
  standalone: true,
  imports: [SharedModule],
  templateUrl: "./sms-shipping-settings.component.html",
})
export class SmsShippingSettingsComponent
  implements CustomDetailComponent, OnInit
{
  entity$: Observable<any>;
  detailForm: FormGroup;

  b2b = true;
  b2c = true;
  saving = false;

  constructor(
    private dataService: DataService,
    private notificationService: NotificationService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    // Fields are internal (not exposed on the standard GlobalSettings API), so
    // read the current values via the dedicated query.
    this.dataService
      .query(GetSmsShippingSettingsDocument)
      .single$.pipe(take(1))
      .subscribe((res) => {
        const s = res?.smsShippingSettings;
        if (s) {
          this.b2b = s.smsShippingEnabledB2B ?? true;
          this.b2c = s.smsShippingEnabledB2C ?? true;
          this.cdr.markForCheck();
        }
      });
  }

  save(): void {
    this.saving = true;
    this.dataService
      .mutate(UpdateSmsShippingSettingsDocument, {
        smsShippingEnabledB2B: this.b2b,
        smsShippingEnabledB2C: this.b2c,
      })
      .pipe(take(1))
      .subscribe({
        next: () => {
          this.saving = false;
          this.notificationService.success("Shipping SMS settings updated");
          this.cdr.markForCheck();
        },
        error: () => {
          this.saving = false;
          this.notificationService.error("Failed to update shipping SMS settings");
          this.cdr.markForCheck();
        },
      });
  }
}
